<template>
	<div>
		<app-inbox-loading v-if="isDataLoading" />
		<div v-else>
			<b-row v-if="false">
				<b-col>
					<b-button class="btn-close-page float-right mb-2" @click="$emit('closePage')" v-b-tooltip.hover title="Close"><b-icon-x /></b-button>
				</b-col>
			</b-row>
			<b-card header="Stock Adjustment" class="mb-3">
				<b-row>
					<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Stock Adjustment Number" :model="model.stockAdjustmentNumber" />
						<app-input-datepicker  id="fieldset-stock-adjustment-date" label-cols-lg="12" label="Stock Adjustment Date" size="sm" :model.sync="model.stockAdjustmentDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox-autocomplete :options="stockAdjustmentTypes" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Stock Adjustment Type" id="fieldset-stock-adjustment-type" size="sm" :model.sync="model.stockAdjustmentTypeId"   :selected="model.stockAdjustmentType != null ? model.stockAdjustmentType.name : ''" @input="getStockAdjustmentTypes" @change="updateData" :isEditable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedStockAdjustmentType" :isUpdatable="true"/>
					</b-col>
					<b-col cols="12" lg="6">
					</b-col>
				</b-row>
			</b-card>

		<app-table-input-popup title="Stock Adjustment Detail" :bordered="true" :items="stockAdjustmentDetails" :fields="fieldsStockAdjustmentDetail" :busy="isDataLoading" :sort-by.sync="sortByStockAdjustmentDetail" :sort-desc.sync="sortDescStockAdjustmentDetail" small responsive
			@editButtonMethod="editRowDataStockAdjustmentDetail"
			@deleteButtonMethod="deleteRowDataStockAdjustmentDetail"
			@showPopupAddMethod="resetDataStockAdjustmentDetail()"
			@showPopupUploadMethod="showPopupUploadStockAdjustmentDetail()"
			@downloadMethod="downloadStockAdjustmentDetail()"
			@addFromClipboardMethod="addFromClipboardStockAdjustmentDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardStockAdjustmentDetail()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadStockAdjustmentDetail"
			>
			<template #top-row v-if="isShowStockAdjustmentDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
							<b-th stacked-heading="Control Card">
								<v-select append-to-body label="controlCardNumber" :options="controlCards"  :value="filterStockAdjustmentDetail.controlCardId" :reduce="item => item.id" v-model="filterStockAdjustmentDetail.controlCardId" @search="getControlCards" :filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Part">
								<v-select append-to-body label="partNumber" :options="parts"  :value="filterStockAdjustmentDetail.partId" :reduce="item => item.id" v-model="filterStockAdjustmentDetail.partId" @search="getParts" :filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Qty Sistem">
								<b-form-input id="input-qty-sytem-table" v-model="filterStockAdjustmentDetail.qtySytem" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Qty Adjustment">
								<b-form-input id="input-qty-adjustment-table" v-model="filterStockAdjustmentDetail.qtyAdjustment" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Qty After">
								<b-form-input id="input-qty-after-table" v-model="filterStockAdjustmentDetail.qtyAfter" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Reason">
								<b-form-input id="input-reason-table" v-model="filterStockAdjustmentDetail.reason" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Control Card Status Before ">
								<v-select append-to-body label="name" :options="controlCardStatuss"  :value="filterStockAdjustmentDetail.controlCardStatusBeforeId" :reduce="item => item.id" v-model="filterStockAdjustmentDetail.controlCardStatusBeforeId" @search="getControlCardStatuss" :filterable="true"></v-select>
							</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( stockAdjustmentDetailPageSize * (currentStockAdjustmentDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								<template v-slot:cell(controlCard)="row">
									<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-stock-adjustment-detail-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId" :state="validateState('controlCardId')" :errorMessage="getErrorMessage(errorMessage.controlCardId, 'controlCardId')"  @change="saveInputStockAdjustmentDetail(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"  :isEditable="false"  :isUpdatable="true" :nolabel="true"  />
								</template>
								<template v-slot:cell(part)="row">
									<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-stock-adjustment-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"  @change="saveInputStockAdjustmentDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isEditable="false"  :isUpdatable="true" :nolabel="true"  />
								</template>
								<template v-slot:cell(qtySytem)="row">
									<app-input-textbox :id="'input-stock-adjustment-detail-qty-sytem-' + row.index" label-cols-lg="12" label="Qty Sistem" size="sm" :model.sync="row.item.qtySytem"   @change="saveInputStockAdjustmentDetail(row.item)" :isEditable="false"  :isUpdatable="true" :nolabel="true"  />
								</template>
								<template v-slot:cell(qtyAdjustment)="row">
									<app-input-textbox :id="'input-stock-adjustment-detail-qty-adjustment-' + row.index" label-cols-lg="12" label="Qty Adjustment" size="sm" :model.sync="row.item.qtyAdjustment" :state="validateState('qtyAdjustment')" :errorMessage="getErrorMessage(errorMessage.qtyAdjustment, 'qtyAdjustment')"   @change="saveInputStockAdjustmentDetail(row.item)" :isEditable="false"  :isUpdatable="true" :nolabel="true"  />
								</template>
								<template v-slot:cell(qtyAfter)="row">
									<app-input-textbox :id="'input-stock-adjustment-detail-qty-after-' + row.index" label-cols-lg="12" label="Qty After" size="sm" :model.sync="row.item.qtyAfter"   @change="saveInputStockAdjustmentDetail(row.item)" :isEditable="false"  :isUpdatable="true" :nolabel="true"  />
								</template>
								<template v-slot:cell(supplierCaseNumberGr)="row">
									<app-input-textbox :id="'input-stock-adjustment-detail-supplier-case-number-gr-' + row.index" label-cols-lg="12" label="Supplier Case Number GR" size="sm" :model.sync="row.item.supplierCaseNumberGr"   @change="saveInputStockAdjustmentDetail(row.item)" :isUpdatable="null" :isEditable="false" :nolabel="true" />
								</template>
								<template v-slot:cell(reason)="row">
									<app-input-textarea :id="'input-stock-adjustment-detail-reason-' + row.index" label-cols-lg="12" label="Reason" size="sm" :model.sync="row.item.reason" :state="validateState('reason')" :errorMessage="getErrorMessage(errorMessage.reason, 'reason')"  @change="saveInputStockAdjustmentDetail(row.item)" :isEditable="false"  :isUpdatable="true" :nolabel="true"  />
								</template>
								<!-- <template v-slot:cell(controlCardStatusBefore)="row">
									<app-input-combobox-autocomplete :options="controlCardStatuss" optionsLabel="name" optionsKey="id" :id="'input-stock-adjustment-detail-control-card-status-before-' + row.index" label-cols-lg="12" label="Control Card Status Before " size="sm" :model.sync="row.item.controlCardStatusBeforeId"  @change="saveInputStockAdjustmentDetail(row.item)" :selected="row.item.controlCardStatusBefore != null ? row.item.controlCardStatusBefore.name : ''"  @input="getControlCardStatuss" :loading="isControlCardStatusComboLoading"  :isEditable="false"  :isUpdatable="true" :nolabel="true"  />
								</template> -->

			<template v-slot:form-add-detail>
				<StockAdjustmentDetailInput 
					:openPopup="isShowPopupStockAdjustmentDetail"
					:modelId="stockAdjustmentDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataStockAdjustmentDetail"/>
			</template>
			<template v-slot:upload-detail>
				<StockAdjustmentDetailUpload
					:openPopup="isShowPopupUploadStockAdjustmentDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataStockAdjustmentDetail"
					:parentId="modelId"
					/>
			</template>
						<template #row-details="row">
							<b-card>
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-stock-adjustment-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"  @change="saveInputStockAdjustmentDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isUpdatable="true" :isEditable="true"  />
					<app-input-textbox :id="'input-stock-adjustment-detail-qty-sytem-' + row.index" label-cols-lg="12" label="Qty Sistem" size="sm" :model.sync="row.item.qtySytem"   @change="saveInputStockAdjustmentDetail(row.item)" :isUpdatable="true" :isEditable="true"  />
					<app-input-textbox :id="'input-stock-adjustment-detail-qty-adjustment-' + row.index" label-cols-lg="12" label="Qty Adjustment" size="sm" :model.sync="row.item.qtyAdjustment" :state="validateState('qtyAdjustment')" :errorMessage="getErrorMessage(errorMessage.qtyAdjustment, 'qtyAdjustment')"   @change="saveInputStockAdjustmentDetail(row.item)" :isUpdatable="true" :isEditable="true"  />
					<app-input-textbox :id="'input-stock-adjustment-detail-qty-after-' + row.index" label-cols-lg="12" label="Qty After" size="sm" :model.sync="row.item.qtyAfter"   @change="saveInputStockAdjustmentDetail(row.item)" :isUpdatable="true" :isEditable="true"  />
					<app-input-textbox :id="'input-stock-adjustment-detail-supplier-case-number-gr-' + row.index" label-cols-lg="12" label="Supplier Case Number" size="sm" :model.sync="row.item.supplierCaseNumberGr"   @change="saveInputStockAdjustmentDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textarea :id="'input-stock-adjustment-detail-reason-' + row.index" label-cols-lg="12" label="Reason" size="sm" :model.sync="row.item.reason" :state="validateState('reason')" :errorMessage="getErrorMessage(errorMessage.reason, 'reason')"  @change="saveInputStockAdjustmentDetail(row.item)" :isUpdatable="true" :isEditable="true"  />
					<!-- <app-input-combobox-autocomplete :options="controlCardStatuss" optionsLabel="name" optionsKey="id" :id="'input-stock-adjustment-detail-control-card-status-before-' + row.index" label-cols-lg="12" label="Control Card Status Before " size="sm" :model.sync="row.item.controlCardStatusBeforeId"  @change="saveInputStockAdjustmentDetail(row.item)" :selected="row.item.controlCardStatusBefore != null ? row.item.controlCardStatusBefore.name : ''"  @input="getControlCardStatuss" :loading="isControlCardStatusComboLoading"  :isUpdatable="true" :isEditable="true"  /> -->
							</b-card>
						</template>

		</app-table-input-popup>
			<b-overlay :show="isBusy" no-wrap></b-overlay>
			<Portal to="app-inbox-button">
				<app-approval-button
					@approveMethod="submitAction" 
					:showApproveButton="true" 
					approveButtonTitle="Submit Request" 
					@revisionMethod="editDraftAction"
					:showRevisionButton="true"
					revisionButtonTitle="Edit Draft"
					@rejectMethod="discardAction" 
					:showRejectButton="true" 
					rejectButtonTitle="Discard Request" 
				/>
			</Portal>
		</div>
	</div>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import StockAdjustment from '@/models/StockAdjustment/StockAdjustment';
import StockAdjustmentList from '@/models/StockAdjustment/StockAdjustmentList';
import StockAdjustmentFilter from '@/filters/StockAdjustment/StockAdjustmentFilter';

import AppInputTextarea from '@/components/AppInputTextarea';
import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import StockAdjustmentType from '@/models/StockAdjustmentType/StockAdjustmentType';
import StockAdjustmentTypeFilter from '@/filters/StockAdjustmentType/StockAdjustmentTypeFilter';
import StockAdjustmentDetail from '@/models/StockAdjustment/StockAdjustmentDetail';
import StockAdjustmentDetailFilter from '@/filters/StockAdjustment/StockAdjustmentDetailFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import ControlCardStatus from '@/models/ControlCardStatus/ControlCardStatus';
import ControlCardStatusFilter from '@/filters/ControlCardStatus/ControlCardStatusFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import StockAdjustmentDetailInput from '@/views/StockAdjustment/StockAdjustmentDetailInput';
import StockAdjustmentDetailUpload from '@/views/StockAdjustment/StockAdjustmentDetailUpload';

import PopupRouterView from '@/components/PopupRouterView';
import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import PopupRouterViewApprovalDetail from '@/components/PopupRouterViewApprovalDetail';
import AppApprovalButton from '@/components/AppApprovalButton';

export default {
	props: 
		{
			selectedModelId: {
				default: "",
				type: String
			},
			selectedModel: {
				default: null,
				type: Object
			},
			successAction: {},
			inboxType: {
				default: "",
				type: String
			}
		}
	,
	components : {
		AppLabel,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		StockAdjustmentDetailInput,
		StockAdjustmentDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewApprovalDetail, 
		PopupRouterView,
		AppApprovalButton,
		AppInputTextarea,

		PopupRouterViewApprovalDetail, 
		PopupRouterViewDetail,
		PopupRouterView,
		AppApprovalButton,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},

	data() {
		return {
			errorMessage : {
			},

			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			isShowDataDetailFilter: false,
			isDownloadDataDetail: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			backroute: '',
			approvalConfiguration: {},
			fieldsStockAdjustmentDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card first-child", "label" : "Control Card", key: 'controlCard', sortable: true }}, 
				{"part": { "class" : "th-part", "label" : "Part", key: 'part', sortable: true }}, 
				{"qtySytem": { "class" : "th-qty-sytem last-child", "label" : "Qty Sistem", key: 'qtySytem', sortable: true }}, 
				{"qtyAdjustment": { "class" : "th-qty-adjustment d-stack-none", "label" : "Qty Adjustment", key: 'qtyAdjustment', sortable: true }}, 
				{"qtyAfter": { "class" : "th-qty-after d-stack-none", "label" : "Qty After", key: 'qtyAfter', sortable: true }}, 
				{"supplierCaseNumberGr": { "class" : "th-supplier-case-number-gr d-stack-none", "label" : "Supplier Case Number GR", key: 'supplierCaseNumberGr', sortable: false}}, 
				{"reason": { "class" : "th-reason d-stack-none", "label" : "Reason", key: 'reason', sortable: true }}, 
				// {"controlCardStatusBefore": { "class" : "th-control-card-status-before d-stack-none", "label" : "Control Card Status Before ", key: 'controlCardStatusBefore', sortable: true }}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			modelStockAdjustmentDetail : {},
			isShowPopupStockAdjustmentDetail : false,
			isShowPopupUploadStockAdjustmentDetail : false,
			filterStockAdjustment : null,
			currentStockAdjustmentPage : 1,
			stockAdjustmentPageSize: 10,
			sortByStockAdjustment: '',
			sortDescStockAdjustment: '',
			filterStockAdjustmentDetail : null,
			currentStockAdjustmentDetailPage : 1,
			stockAdjustmentDetailPageSize: 10,
			sortByStockAdjustmentDetail: '',
			sortDescStockAdjustmentDetail: '',
			sortingByStockAdjustmentDetail: [],
			stockAdjustmentDetails : [],
			stockAdjustmentDetailId : '',
			totalStockAdjustmentDetailRow : 0,
			isShowStockAdjustmentDetailFilter: false,
			isDownloadStockAdjustmentDetail: false,
			controlCards: [],
			parts: [],
			controlCardStatuss: [],
			stockAdjustmentTypes: [],
			stockAdjustmentTypes: [],
			isStockAdjustmentTypeComboLoading: false,
			backroute: '',
			isStockAdjustmentTypeComboLoading: false,
			isStockAdjustmentComboLoading: false,
			isControlCardComboLoading: false,
			isPartComboLoading: false,
			isControlCardStatusComboLoading: false,

		}
	},
	methods : {
		getStockAdjustment : async function(id) {
			this.isDataLoading = true;
			this.getStockAdjustmentDetails();

			
			StockAdjustment.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				//StockAdjustment.getApprovalConfigurationInput(this, result.approvalInstanceId).then(result => { this.approvalConfiguration = result; this.isDataLoading = false; }).catch(() => { this.isDataLoading = false; });
				this.isDataLoading = false;
			}).catch(error => { this.isDataLoading = false; });
		},
		downloadData() {
			this.isDownloadStockAdjustment = true;
			this.filterStockAdjustment.id = this.modelId;
			StockAdjustment.downloadDataDetail(this, this.filterStockAdjustment).then(result => {
				this.isDownloadStockAdjustment = false;
			}).catch(error => { this.isDownloadStockAdjustment = false; })
		},
		getStockAdjustmentDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterStockAdjustmentDetail);
			if (this.modelId == null) return;
			filter.stockAdjustmentId = this.modelId;
			//filter.draftMode = "0";
			if (this.sortByStockAdjustmentDetail != null) {
				this.sortingByStockAdjustmentDetail[this.sortByStockAdjustmentDetail] = this.sortDescStockAdjustmentDetail;
			}
			let currentPage = (this.currentStockAdjustmentDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalStockAdjustmentDetailRow + 1;
				let page = Math.ceil(totalData/this.stockAdjustmentDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.stockAdjustmentDetailPageSize = 0;
			// disable paging end
			StockAdjustmentDetail.getList(this, filter, this.sortingByStockAdjustmentDetail, currentPage , this.stockAdjustmentDetailPageSize).then(result => {
				this.currentStockAdjustmentDetailPage = currentPage + 1;
				this.stockAdjustmentDetails = result.data;
				this.totalStockAdjustmentDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getStockAdjustments : async function(input) {
			let filter = new StockAdjustmentFilter();
			if (input != undefined) {
				filter.stockAdjustmentNumber = input;
			}
			this.isStockAdjustmentComboLoading = true;
			StockAdjustment.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockAdjustments = result.data
				}
				this.isStockAdjustmentComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCardStatuss : async function(input) {
			let filter = new ControlCardStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isControlCardStatusComboLoading = true;
			ControlCardStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCardStatuss = result.data
				}
				this.isControlCardStatusComboLoading = false;
			})
			.catch(error => {});
		},
		getStockAdjustmentTypes : async function(input) {
			let filter = new StockAdjustmentTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			StockAdjustmentType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.stockAdjustmentTypes = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedStockAdjustmentType(item) {
			if(item == undefined || item == null) {
				this.model.stockAdjustmentTypeId = null;
				this.model.stockAdjustmentType = null;
			} else {
				this.model.stockAdjustmentTypeId = item.id;
				this.model.stockAdjustmentType = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;

			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					StockAdjustment.updateData(this, model, id);
				}
			});
		},

		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					StockAdjustment.updateData(this, model, id);
				}
			});
		},
		editDraftAction(modelEvent) {
			let id = this.modelId;
			if(id != '' && id != null && id != undefined) {
				this.$router.push({ name: 'stockadjustmentcreateinboxrequest', params : { id: id } });
			}
		},
		submitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				StockAdjustment.submitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		approveAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to approve this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							StockAdjustment.approveApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		rejectAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to reject this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							StockAdjustment.rejectApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		reviseAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to ask for revision for this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							StockAdjustment.reviseApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		editRequestAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				StockAdjustment.editRequest(this, id).then(result => {
					if (result != null) {
						if (result.id != null && result.id != "") {
							this.$router.push({ name: 'stockadjustmentcreateinboxrequest', params : { id: result.id } });
						}
					}
					this.isCreateBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		discardAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to discard this data?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
						this.isBusy = true;
						StockAdjustment.discardData(this, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		resubmitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				StockAdjustment.resubmitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		cancelAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to cancel this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
						this.isBusy = true;
						StockAdjustment.cancelApprovalData(this, model, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		onHidden() {
			// this.getStockAdjustments();
		},
		addRowDataStockAdjustmentDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.stockAdjustmentId =  this.modelId;
					StockAdjustmentDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getStockAdjustmentDetails(true);
						this.isShowPopupStockAdjustmentDetail = false;
					})
				} else {
					model.stockAdjustmentId =  this.modelId;
					StockAdjustmentDetail.createData(this, model)
					.then(result => {
						this.getStockAdjustmentDetails(true);
						this.isShowPopupStockAdjustmentDetail = false;
					})
				}
			}
		},
		async editRowDataStockAdjustmentDetail(id) {
			this.stockAdjustmentDetailId = id;
			this.isShowPopupStockAdjustmentDetail = true; 
		},
		async deleteRowDataStockAdjustmentDetail(id) {
			StockAdjustmentDetail.deleteData(this, id).then(result => { this.getStockAdjustmentDetails(); });
		},
		async resetDataStockAdjustmentDetail() {
			this.stockAdjustmentDetailId = "";
			this.isShowPopupStockAdjustmentDetail = true;
		},
		async addDataStockAdjustmentDetail() {
			StockAdjustmentDetail.createData(this, { stockAdjustmentId: this.modelId })
			.then(result => {
				this.getStockAdjustmentDetails(true);
			})
		},
		async addFromClipboardStockAdjustmentDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, stockAdjustmentId: this.modelId });
				});
				StockAdjustmentDetail.addFromClipboard(this, controlCards).then(result => { this.getStockAdjustmentDetails() });
			});
		},
		async replaceFromClipboardStockAdjustmentDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, stockAdjustmentId: this.modelId });
				});
				StockAdjustmentDetail.replaceFromClipboard(this, controlCards).then(result => { this.getStockAdjustmentDetails() });
			});   
		},
		showPopupUploadStockAdjustmentDetail() {
			this.isShowPopupUploadStockAdjustmentDetail = true;
		},
		uploadDataStockAdjustmentDetail(modalEvent, newDatas) {
			this.isShowPopupUploadStockAdjustmentDetail = false; 
		},
		downloadStockAdjustmentDetail(modalEvent) {
			this.isDownloadStockAdjustmentDetail = true;
			this.filterStockAdjustmentDetail.stockAdjustmentId = this.modelId;
			StockAdjustmentDetail.downloadDataDetail(this, this.filterStockAdjustmentDetail).then(result => {
				this.isDownloadStockAdjustmentDetail = false;
			}).catch(error => { this.isDownloadStockAdjustmentDetail = false; })
		},
		saveInputStockAdjustmentDetail(item) {
			StockAdjustmentDetail.updateDataDetail(this, item, item.id);
		},

		resetModal(modalType) {
			this.isShowPopupUploadStockAdjustmentDetail = false; 
			this.isShowPopupStockAdjustmentDetail = false; 
			if (modalType == 'StockAdjustmentDetail') {
				this.getStockAdjustmentDetails();
			}

			//this.showPopupCopyData = false; 
			//this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowStockAdjustmentDetailFilter = true;

			}
		},
	},
	beforeMount() {
		//this.filterStockAdjustment = new StockAdjustmentFilter();
//this.filterStockAdjustment = new StockAdjustmentFilter();
		this.filterStockAdjustmentDetail = new StockAdjustmentDetailFilter();
		//this.getStockAdjustments();
		//this.getControlCards();
		//this.getParts();
		//this.getControlCardStatuss();
		//this.getStockAdjustmentTypes();


		//this.getStockAdjustments();
	},
	async mounted() {
		if (this.selectedModel != null && this.selectedModel != "") {
			this.modelId = this.selectedModel.id;
			this.model = this.selectedModel;
			this.getDataDetails();
		} else if (this.selectedModelId != null && this.selectedModelId != "") {
			this.modelId = this.selectedModelId;
			this.getStockAdjustment(this.selectedModelId);
		}
	},
	computed: {
		disableRejectRevise() {
			if (this.model.approvalRemarks == undefined || this.model.approvalRemarks == null || this.model.approvalRemarks == '') return true;
			return false;
		},
	},
	watch : {
		selectedModelId(newValue, oldValue) {
			if (newValue != oldValue) {
				this.modelId = newValue;
				this.getStockAdjustment(newValue);
			}
		},
		selectedModel(newValue, oldValue) {
			if (newValue != oldValue) {
				this.modelId = newValue.id;
				this.model = newValue;
				this.getStockAdjustmentDetails();
			}
		},
		sortByStockAdjustmentDetail : {
			handler: function() {
				this.getStockAdjustmentDetails();
			}
		},
		sortDescStockAdjustmentDetail: {
			handler: function() {
				this.getStockAdjustmentDetails();
			}
		},
		currentStockAdjustmentDetailPage: {
			handler: function() {
				this.getStockAdjustmentDetails();
			}
		},
		stockAdjustmentDetailPageSize : {
			handler: function() {
				this.getStockAdjustmentDetails();
			}
		},
		filterStockAdjustmentDetail: {
			handler: function() {
				this.getStockAdjustmentDetails();
			},
			deep: true,
		},


	},
}
</script>
